import React from 'react';
import { Box, Typography, Card, CardContent, CardMedia } from '@mui/material';
import PromotionsCarousel from './PromotionsCarousel.tsx'; // Import promotions carousel

const services = [
    {
        title: 'Self Service',
        description: 'Clean, friendly, and safe environment for your laundry day.',
        image: '/SelfService.png',
    },
    {
        title: 'Wash, Dry & Fold',
        description: 'Drop off your laundry and we\'ll do it for you.',
        image: '/DropOff.jpeg',
    },
    {
        title: 'Pickup & Delivery',
        description: 'Now available - easy laundry day. You must be within 30 miles of our location for us to deliver.',
        image: '/Delivery.png',
    },
    {
        title: 'Commercial Laundry',
        description: 'Let us save your business time with our commercial laundry service!',
        image: '/CommericalLaundry.jpeg',
    },
    {
        title: 'Dry Cleaning',
        description: 'We take the utmost care to ensure your garments come back fresh and pressed.',
        image: '/DryCleaning.jpg',
    },
];

const ServicesList: React.FC = () => {
    return (
        <Box sx={{ py: 5, textAlign: 'center', backgroundColor: 'background.default' }}>
            <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 3 }}>
                OUR SERVICES
            </Typography>

            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
                    gap: 4,
                    justifyContent: 'center',
                    px: 2,
                }}
            >
                {services.map((service, index) => (
                    <Card
                        key={index}
                        sx={{
                            height: '100%',
                            boxShadow: 4,
                            transition: 'transform 0.3s ease-in-out',
                            '&:hover': { transform: 'scale(1.05)' },
                        }}
                    >
                        <CardMedia
                            component="img"
                            height="180"
                            image={service.image}
                            alt={service.title}
                        />
                        <CardContent>
                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                {service.title}
                            </Typography>
                            <Typography variant="body2" sx={{ mt: 1 }}>
                                {service.description}
                            </Typography>
                        </CardContent>
                    </Card>
                ))}

                <Card
                    sx={{
                        height: '100%',
                        boxShadow: 4,
                        padding: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        transition: 'transform 0.3s ease-in-out',
                        '&:hover': { transform: 'scale(1.05)' },
                    }}
                >
                    <CardContent sx={{ flexGrow: 1 }}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
                            Current Promotions
                        </Typography>
                        <Box sx={{ width: '100%', height: '220px', display: 'flex', justifyContent: 'center' }}>
                            <PromotionsCarousel />
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};

export default ServicesList;
